import request from 'local_modules/request'
import { constants } from 'helpers'
import { reducers, getState } from 'redux/core'


const setFetching = (isFetching) => reducers.marketplace.adminLearnCalculatePage.setFetching(isFetching)

const fetchGroups = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learn + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      if (data && data.length) {
        return data.filter(({ active } = {}) => active)
      }

      return data
    })
    .then((data) => {
      reducers.marketplace.adminLearnCalculatePage.setGroups(data)
      return data
    })
    .catch((error) => console.log(error))
}

const fetchGroupMembers = ({ groupId, groupScheduleId }) => {
  return request.get(constants.marketplace.learnGroup + `/${groupId}/member?all=true` + (groupScheduleId ? `&groupScheduleId=${groupScheduleId}` : ''))
    .then(({ data }) => data)
    .then((data) => {
      reducers.marketplace.adminLearnCalculatePage.setGroupMembers({ groupId, members: data })

      return data
    })
    .catch((error) => console.log(error))
}

// const setGroupMembers = ({ groupId, members }) => {
//   reducers.marketplace.adminLearnCalculatePage.setGroupMembers({ groupId, members })
// }
//
// const fetchGroupMember = ({ id: groupId, memberId, groupScheduleId }) => {
//   return request.get(constants.marketplace.learnGroup + `/${groupId}/member/${memberId}?groupScheduleId=${groupScheduleId}`)
//     .then(({ data }) => data)
//     .then((data) => {
//       // reducers.marketplace.adminLearnCalculatePage.setGroupMember({ groupId, memberId, member: data })
//
//       return data
//     })
//     .catch((error) => console.log(error))
// }

const fetchGroupMemberTotal = ({ groupId, memberId, groupScheduleId }) => {
  return request.get(constants.marketplace.learnGroup + `/${groupId}/member/${memberId}?groupScheduleId=${groupScheduleId}`)
    .then(({ data }) => data)
    .then((data) => {
      const { status, total, errormsg, subscription } = data

      // reducers.marketplace.adminLearnCalculatePage.setGroupMemberTotal({ groupId, memberId, total: data })

      if (status !== 0) {
        console.error(`${errormsg}, groupId: ${groupId}, subscriberId: ${memberId}`)
      }

      return { groupId, memberId, total: data }
    })
    .catch((error) => console.log(error))
}

const setGroupMembersTotal = (data) => reducers.marketplace.adminLearnCalculatePage.setGroupMembersTotal(data)

// const setGroupMembers = ({ groupId, members }) => {
//   return request.post(constants.marketplace.learnGroup + `/${groupId}/member?all=true`, members)
//     .then(({ data }) => data)
//     .catch((error) => console.log(error))
// }

const fetchGroupQuantity = (groupId) => {
  return request.get(constants.marketplace.learnGroup + `/${groupId}/schedule`)
    .then(({ data }) => data)
    .then((data) => reducers.marketplace.adminLearnCalculatePage.setGroupQuantity({ groupId, quantity: data }))
    .catch((error) => console.log(error))
}

const setGroupQuantity = ({ groupId, quantity }) => {
  return request.post(constants.marketplace.learnGroup + `/${groupId}/schedule`, quantity)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const recalcSubscription = ({ subscriptionId, count }) => {
  return request.put(constants.marketplace.learnSubscription + `/${subscriptionId}/${count}`, {})
    .then(({ data }) => data)
  // .catch((error) => console.log(error))
}

const createSubscription = ({ memberId, groupScheduleId }) => {
  return request.post(constants.marketplace.learnCreate + `/${memberId}/${groupScheduleId}`, {})
    .then(({ data }) => data)
}


export default {
  setFetching,
  fetchGroups,
  fetchGroupMembers,
  // setGroupMembers,
  setGroupQuantity,
  fetchGroupQuantity,
  fetchGroupMemberTotal,
  setGroupMembersTotal,
  recalcSubscription,
  createSubscription,
  // fetchGroupMember,
}
